export default __webpack_public_path__ + "static/media/Software-Salas-Reuniao.5b9741a0.png";